<template>
  <div class="account-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <div v-if="showspinner">
        <loader></loader>
      </div>
      <div v-else>
        <div class="container">
          <div class="row" style="display:flex;justify-content: center; text-align: center;">
            <div class="col-md-12 col-lg-12 col-xl-12">
              <div>
                <div class="form-group col-sm-12 mt-4" v-if="hospitals.length > 0">
                  <input v-model="hospitalNameFilter" type="text" class="form-control"
                    placeholder="Search by Hospital's Name" />
                </div>
                <div class="hospital-card-container">
                  <div v-for="(item, index) in filteredHospitals" v-bind:key="index" v-show="setPaginate(index)"
                    class="hospital-card">
                      <h3 style="background-color: rgb(239, 238, 238); height: 60px;padding-top:10px;">{{ item.name_of_hospital }}</h3>
                      <img :src="'https://develop-physio.kneexpert.in' + item.logo" alt="Hospital Logo"
                        class="hospital-logo" style="padding: 5px;"/>
                      <p style="height: 45px;padding:2px;">{{ item.address }}</p>
                      <p>{{ item.city }}, {{ item.state }}, {{ item.pincode }}</p>
                      <div class="row justify-content-center">
                        <div class="col-md-3 mr-md-1">
                                <router-link :to="{
                                  name: 'hospital-doctor',
                                  params: { name: item.name },
                                }">
                                  <button class="new_btn btn btn-primary btn-sm mb-2">
                                    Doctors
                                  </button>
                                </router-link>
                              </div>
                              <div class="col-md-5">
                                <router-link :to="{ name: 'searchhospital', params: { hospital: item.name } }">
                        <div>
                      <button class="new_btn btn btn-primary btn-sm mb-2">Departments</button>
                    </div>
                    </router-link>
                              </div>
                      </div>
                  </div>
                </div>
                <div class="row justify-content-center" v-if="filteredHospitals.length > 0">
                <div>
                <h5 class="mt-1" style="color: #8d8c8c;">Total Hospitals : {{ hospital_total }}</h5>
              </div>
              </div>
                <!-- pagination start -->
                <div id="pagination" class="ml-3" v-if="filteredHospitals.length > paginate">
                  <ul class="pagination justify-content-center">
                    <!-- "Previous" Button -->
                    <li class="page-item" :class="current === 1 ? 'disabled' : ''">
                      <a href="#" class="page-link" aria-label="Previous"
                        @click.prevent="updateInvestigationCount(current - 1)">
                        Previous
                      </a>
                    </li>
                    <!-- Pagination Links (Display 5 at a time) -->
                    <li v-for="page_index in totalPages" :key="page_index"
                      :class="['page-item', current === page_index ? 'active' : '']"
                      v-if="page_index >= current - 2 && page_index <= current + 2">
                      <a href="#" class="page-link" @click.prevent="updateInvestigationCount(page_index)">
                        {{ page_index }}
                      </a>
                    </li>
                    <!-- "Next" Button -->
                    <li class="page-item" :class="current === totalPages ? 'disabled' : ''">
                      <a href="#" class="page-link" aria-label="Next"
                        @click.prevent="updateInvestigationCount(current + 1)">
                        Next
                      </a>
                    </li>
                  </ul>
                </div>
                <!-- pagination end -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <layout-footer v-if="hospitals.length > 0"></layout-footer>
    </div>
  </div>
</template>
  
<script>
import axios from 'axios';

export default {
  name: 'HospitalCard',
  data() {
    return {
      hospital_total:0,
      showspinner: true,
      hospitals: [],
      city: '', // Store the city obtained from the first API
      hospitalNameFilter: "",
      current: 1,
      paginate: 12,
      paginate_total: 0,
    };
  },

  computed: {
    totalPages() {
      return Math.ceil(this.filteredHospitals.length / this.paginate);
    },
    filteredHospitals() {
      return this.hospitals.filter(hospital =>
        hospital.name_of_hospital.toLowerCase().includes(this.hospitalNameFilter.toLowerCase())
      );
    },
  },

  mounted() {
    this.getCityFromFirstAPI();
  },
  methods: {

    setPaginate(index) {
      const start = (this.current - 1) * this.paginate;
      const end = this.current * this.paginate;
      return index >= start && index < end;
    },

    //pagination start
    updateInvestigationCount(i) {
      this.current = i;
      document.getElementById("doctors_container").scrollIntoView();
    },

    setPaginate(i) {
      if (this.current == 1) {
        return i < this.paginate;
      } else {
        return (
          i >= this.paginate * (this.current - 1) &&
          i < this.current * this.paginate
        );
      }
    },
    //pagination end

    async getCityFromFirstAPI() {
      try {
        const response = await axios.get('https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=' + window.location.hostname);
        if (response.data.status_code === 200 && response.data.data.length > 0) {
          this.city = response.data.data[0].city; // Extract city from the response
          this.fetchHospitals();
        } else if (response.data.status_code === 404) {
          // Handle 404 error
        }
        this.showspinner = false;
      } catch (error) {
        console.error("Error fetching city:", error);
        this.showspinner = false;
      }
    },
    async fetchHospitals() {
      try {
        const response = await axios.get('https://develop-physio.kneexpert.in/api/method/sahaj.api.get_hospitals');
        if (response.data && response.data.data) {
          // Filter hospitals based on the city
          this.hospitals = response.data.data.filter(hospital => hospital.city === this.city);
          this.hospital_total = this.hospitals.length;
        }
      } catch (error) {
        console.error("Error fetching hospitals:", error);
      }
    }
  }
};
</script>
  
<style scoped>
.hospital-card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* Centers the cards horizontally */
  gap: 20px;
  margin: 30px auto;
  /* 30px margin on top and bottom, auto centers the container */
  max-width: 90%;
  /* Adjust as needed to control the container width */
}

.hospital-card {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  width: 250px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  /* Centers the content inside the card */
}


.hospital-logo {
  width: 70px;
  height: 70px;
  object-fit: cover;
  margin: 0 auto 10px;
  /* Horizontally centers the logo and gives 10px margin at the bottom */
  display: block;
  /* Makes the image a block element to respect the margin settings */
}

h3 {
  font-size: 18px;
  margin-bottom: 10px;
}

p {
  font-size: 14px;
  color: #555;
}
.new_btn:hover{
  background-color: #008080;
}

@media screen and (min-width: 1024px) {

  .form-group {
    margin-left: auto;
    /* Center the form group horizontally */
    margin-right: auto;
    width: 430px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/Hospitals.vue